@let _shipment = shipment();

@if (_shipment == null) {
  <h2>Finns inga lediga returer, försök igen senare</h2>
  <a mat-flat-button [routerLink]="['/home']">Stäng</a>
} @else {
  <div class="user-instructions">{{ userInstructions() }}</div>

  <app-shipment-qrcode [shipment]="_shipment" [displayTrackingInfo]="sendInfoToCustomer()" />

  <div class="buttons-container">
    @if (displaySendInfo()) {
      <!-- TODO: modify button text if we have switched to 'send info mode'?-->
      <button mat-flat-button (click)="openSendInfoDialog()">
        Skicka vidare
      </button>
    }

    @if (sendInfoToCustomer()) {
      <a mat-button [routerLink]="['/home']">Stäng</a>
    } @else {
      <button mat-flat-button (click)="submitShipment()">Inlämnad</button>
      <button mat-stroked-button (click)="cancelShipment()">Avbryt</button>
    }
  </div>
}
